import React, { useState } from "react";
import { toast } from "sonner";

import PhoneImage from "src/assets/images/common/tele-phone.png";
import whiteCurveBg from "src/assets/images/common/curve-white.svg";

import Input from "../app/Input";
import Button from "../app/Button";

import onboardingApis from "../../api/onboarding";

interface RequestCallbackProps {
  programName: string;
}

const RequestCallback: React.FC<RequestCallbackProps> = ({ programName }) => {
  const [formFields, setFormFields] = useState({
    name: "",
    email: "",
    phoneNo: "",
  });
  const [errors, setErrors] = useState({ name: "", email: "", phoneNo: "" });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    switch (name) {
      case "name":
        if (value.trim() === "") {
          setErrors({ ...errors, name: "Name is required" });
        } else {
          setErrors({ ...errors, name: "" });
        }
        setFormFields({ ...formFields, name: value });
        break;

      case "email":
        if (value.trim() === "") {
          setErrors({ ...errors, email: "Email is required" });
        } else if (!value.includes("@") || !value.includes(".")) {
          setErrors({ ...errors, email: "Invalid email" });
        } else if (value.length < 3) {
          setErrors({ ...errors, email: "Email is too short" });
        } else {
          setErrors({ ...errors, email: "" });
        }
        setFormFields({ ...formFields, email: value });
        break;

      case "phoneNo":
        if (value.trim() === "") {
          setErrors({ ...errors, phoneNo: "Phone number is required" });
        } else if (value.length !== 10) {
          setErrors({ ...errors, phoneNo: "Invalid phone number" });
        } else {
          setErrors({ ...errors, phoneNo: "" });
        }
        setFormFields({ ...formFields, phoneNo: value });
        break;

      default:
        break;
    }
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setIsLoading(true);

    const requiredFields: Array<keyof typeof formFields> = [
      "name",
      "email",
      "phoneNo",
    ];
    const newErrors = { ...errors };
    requiredFields.forEach((field) => {
      if (!formFields[field]) {
        newErrors[field] = `${
          field.charAt(0).toUpperCase() + field.slice(1)
        } is required`;
      }
    });
    setErrors(newErrors);

    const isValid = Object.values(newErrors).every((error) => error === "");

    if (isValid) {
      requestCallback(formFields);
    } else {
      console.error("Form has errors!");
    }
  };

  const requestCallback = async (formFields: any) => {
    const payload = {
      name: formFields.name,
      email: formFields.email,
      phone_number: formFields.phoneNo,
      campaign_type: programName,
    };

    const response = await onboardingApis.requestCallback(
      JSON.stringify(payload)
    );

    if (Number(response?.code || 0) === 1) {
      setFormFields({ name: "", email: "", phoneNo: "" });
      setErrors({ name: "", email: "", phoneNo: "" });
      setIsLoading(false);
      toast.success("Callback requested successfully!");
    } else {
      toast.error("Something went wrong!");
      setIsLoading(false);
    }
  };

  return (
    <div className="mt-[40px] bg-[var(--app-secondary)] text-white">
      <div className="rounded-lg pb-10">
        <img
          src={whiteCurveBg}
          alt="nivolumab-hero"
          className="w-full object-cover mb-7"
        />

        <div className="px-5 pt-6 space-y-7">
          <div className="space-y-3">
            <div className="text-3xl font-thin text-white">
              Request callback
            </div>

            <div className="text-base text-gray-200 font-thin">
              Have any doubts? Request a callback and our team of care experts
              will help you get your journey started
            </div>
          </div>

          <form
            className="flex flex-col items-center mt-[60px] w-full"
            // onSubmit={(e) => handleSubmit(e)}
          >
            {/* Form Fields */}
            <div className="flex flex-col gap-4 w-full">
              <div className="w-full">
                <Input
                  label="Your name*"
                  value={formFields.name}
                  onChange={handleChange}
                  placeholder="Enter your name"
                  name="name"
                  type="text"
                  fullWidth
                  labelClassName="text-white"
                  error={!!errors.name}
                  helperText={errors.name}
                />
              </div>

              <div className="w-full">
                <Input
                  label="Email address*"
                  value={formFields.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  name="email"
                  type="email"
                  fullWidth
                  labelClassName="text-white"
                  error={!!errors.email}
                  helperText={errors.email}
                />
              </div>

              <div className="w-full">
                <Input
                  label="Phone number*"
                  value={formFields.phoneNo}
                  onChange={handleChange}
                  placeholder="Enter your phone number"
                  name="phoneNo"
                  type="number"
                  fullWidth
                  labelClassName="text-white"
                  error={!!errors.phoneNo}
                  helperText={errors.phoneNo}
                />
              </div>
            </div>

            {/* Submit Button */}
            <div className="w-full text-center relative mt-9">
              <Button
                variant="contained"
                type="submit"
                onClick={handleSubmit}
                loading={isLoading}
                fullWidth
              >
                Request Callback
              </Button>
            </div>
          </form>
          {/* <div>
            <img
              src={PhoneImage}
              className="w-[250px] max-w-[250px] mx-auto mt-16"
            />
          </div> */}
        </div>

        <img
          src={whiteCurveBg}
          alt="nivolumab-hero"
          className="w-full object-cover pb-12 -mb-12 rotate-180"
        />
      </div>
    </div>
  );
};

export default RequestCallback;
